import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormBuilderOutlineSection,
  BackendMutationUpdateLongFormBuilderOutlineSectionArgs,
} from 'src/types/backend';

import { FRAGMENT_PROJECT_LONG_FORM_SECTION } from './schema';

const MUTATION = gql`
  mutation UpdateLongFormBuilderOutlineSection(
    $id: ID!
    $name: String
    $headline: String!
    $content: String
    $contentMarkup: [ContentMarkupInput!]
    $assetType: AssetTypeEnum
    $generationTool: GenerationToolEnum
    $manualKeywords: [String!]
    $instructions: String
    $generationLength: BlogOutlineSectionGenerationLengthEnum
    $mediaInfo: MediaInfoInput
  ) {
    updateLongFormBuilderOutlineSection(
      id: $id
      name: $name
      headline: $headline
      content: $content
      contentMarkup: $contentMarkup
      assetType: $assetType
      generationTool: $generationTool
      manualKeywords: $manualKeywords
      instructions: $instructions
      generationLength: $generationLength
      mediaInfo: $mediaInfo
    ) {
      ...LongFormSection
    }
  }
  ${FRAGMENT_PROJECT_LONG_FORM_SECTION}
`;

type Variables = Omit<
  BackendMutationUpdateLongFormBuilderOutlineSectionArgs,
  'headline' | 'instructions'
> & {
  instructedWriting?: BackendMutationUpdateLongFormBuilderOutlineSectionArgs['instructions'];
};
type Result = BackendLongFormBuilderOutlineSection;

export const updateLongFormBuilderOutlineSection = async ({
  id,
  name,
  content,
  contentMarkup,
  assetType,
  generationTool,
  manualKeywords,
  instructedWriting,
  generationLength,
  mediaInfo,
}: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      id,
      name,
      headline: '', // for backward compatibility, "headline" is not used in "long form" sections anymore
      content,
      contentMarkup,
      assetType,
      generationTool,
      manualKeywords,
      instructions: instructedWriting,
      generationLength,
      mediaInfo,
    },
  });
  return getSingleProp<Result>(response.data);
};
